const ArrowUp01Icon = /*#__PURE__*/ [
  ["path", { d: "M17.9998 15C17.9998 15 13.5809 9.00001 11.9998 9C10.4187 8.99999 5.99985 15 5.99985 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export { ArrowUp01Icon as default };
//# sourceMappingURL=ArrowUp01Icon.js.map
